import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {pageLoadingStore} from "../PageLoadingStore";
import {WarehouseListItemDto} from "../../api/sls";

class SlsWarehouseListStore {
    get items(): WarehouseListItemDto[] {
        return this._items;
    }

    private set items(value: WarehouseListItemDto[]) {
        this._items = value;
    }

    private _items: WarehouseListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        pageLoadingStore.loading = true
        const result = await catchApi(async () => await api.sls.api.listWarehouses())

        const data = result?.data
        this.items = data?.items || []

        pageLoadingStore.loading = false
    }

}

const slsWarehouseListStore = new SlsWarehouseListStore()

export {
    slsWarehouseListStore
}
